import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-menu" };
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12" };
const _hoisted_10 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_11 = { class: "table table-hover table-fixed bottom0 pw100" };
const _hoisted_12 = { class: "text-center hidden-sm" };
const _hoisted_13 = { class: "hidden-sm" };
const _hoisted_14 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tUser Groups\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_router_link, { to: { name: 'user-group' } }, {
                        default: _withCtx(() => [
                            _createVNode(_component_b_button, { variant: "primary" }, {
                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                        _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                        _createElementVNode("span", { class: "hidden-xs" }, " Add User Group", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ]),
        _cache[18] || (_cache[18] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_b_alert, {
                            variant: "primary",
                            dismissible: "",
                            modelValue: _ctx.showInfoMessage,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.showInfoMessage) = $event))
                        }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createTextVNode("\r\n\t\t\t\t\t\t\tUser groups switch features on for the users in them. A Power User or Client Administrator can use a group feature only when one of their groups has it switched on. Administrators can always use every group feature.\r\n\t\t\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ]),
                _cache[17] || (_cache[17] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("table", _hoisted_11, [
                            _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, "Name"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "hidden-sm" }, "Description"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "w120" }, "Features"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "w120" }, "Members")
                                ])
                            ], -1 /* CACHED */)),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: item.userGroupId
                                    }, [
                                        _createElementVNode("td", _hoisted_12, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[7] || (_cache[7] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _cache[8] || (_cache[8] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.remove(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                                        _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[9] || (_cache[9] = _createTextVNode()),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_router_link, {
                                                to: { name: 'user-group', params: { 'id': item.userGroupId } },
                                                class: "blue"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.name), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                        ]),
                                        _cache[10] || (_cache[10] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.description), 1 /* TEXT */),
                                        _cache[11] || (_cache[11] = _createTextVNode()),
                                        _createElementVNode("td", null, _toDisplayString(item.featureCount), 1 /* TEXT */),
                                        _cache[12] || (_cache[12] = _createTextVNode()),
                                        _createElementVNode("td", null, _toDisplayString(item.memberCount), 1 /* TEXT */)
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[13] || (_cache[13] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "5"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no user groups yet.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.loaded]
                ])
            ])
        ])
    ]));
}
